import { createSlice } from '@reduxjs/toolkit';
import { ApiCategoryType } from 'src/features/Categories/types';

export type CategoriesStateType = {
  items: Array<ApiCategoryType>;
  status: 'idle' | 'pending' | 'failed' | 'succeeded';
  meta: {
    page: number;
    total: number;
    next: null | string;
  };
};

const initialState: CategoriesStateType = {
  items: [],
  status: 'idle',
  meta: {
    page: 1,
    total: 0,
    next: null,
  },
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    fetchCategories: (state, action) => {
      if (!action.payload.items || !action.payload.items.length) return;

      state.items = action.payload.items;
      state.meta.total = action.payload.total;
      state.status = 'succeeded';
    },
    changeStatus: (state, action) => {
      if (!action.payload.item) return;

      state.status = action.payload.item;
    },
    deleteCategory: (state, action) => {
      if (!action.payload.id) return;

      state.meta.total = state.meta.total - 1;

      const index = state.items.findIndex(
        category => category.id === action.payload.id
      );

      if (index > -1) state.items.splice(index, 1);
      else
        state.items = state.items.map(category => ({
          ...category,
          children: category.children.filter(
            category => category.id !== action.payload.id
          ),
        }));
    },
  },
});

export default categoriesSlice.reducer;

export const {
  fetchCategories: fetchCategoriesAction,
  changeStatus: changeStatusAction,
  deleteCategory: deleteCategoryAction,
} = categoriesSlice.actions;
